<template>
	<div>
		<div :id="status.status+'_'+status.rank+'_folded'" class="w3-center" style="display: none;">
			<h1>
				<i class="fa fa-chevron-circle-up w3-text-deep-orange cursor-pointer flow-no-padding-top"
				   @click="unfold(status.status+'_'+status.rank)"></i></h1>
			<h1><b>{{ $t(status.status) }}</b></h1>
		</div>
		<div :id="status.status+'_'+status.rank+'_open'">
			<h1 class="flow-content-header"><b>{{ $t(status.status) }}</b>
				<i class="fa fa-chevron-circle-left w3-text-deep-orange w3-right cursor-pointer"
				   @click="fold(status.status+'_'+status.rank)"></i>
			</h1>

			<div v-if="appointments.length === 0">
				<div class="w3-center flow-blue-color flow-padding-top">
					<b class="w3-panel">{{ $t("noPatients") }}</b>
				</div>
			</div>

			<div v-else :id="status.status+'_'+status.rank+'_cards'" class="flow-padding-top">
<!--				<div v-if="isDressing(status.status)">-->
<!--					<div v-for="cRoom in checkUpRooms" :id="cRoom.id" class="w3-margin-bottom flow-card blue-top">-->

<!--						<h5 class="green-text font-weight-bold w3-center">{{ cRoom.displayName }}</h5>-->
<!--						<div v-for="appointment in filterAppointments(appointments, cRoom.id)"-->
<!--						     @click="removeNotify(appointment, status)">-->
<!--							&lt;!&ndash;Get patient card&ndash;&gt;-->
<!--							<patientCard :appointment="appointment"-->
<!--							             :appointmentStatus="status"-->
<!--							             :plugin="plugin"-->
<!--							             :groups="groups"-->
<!--							             :statuses="statuses"-->
<!--							             :notify="isNotify(appointment,status)">-->
<!--							</patientCard>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->

<!--				<div v-else>-->
					<div
							v-for="(appointment) in (isWaiting(status.status) && sortWaiting===true ? sortedWaitAppointments : appointments)"
							@click="removeNotify(appointment, status)">
						<!--Get patient card-->
						<patientCard :appointment="appointment"
						             :appointmentStatus="status"
						             :plugin="plugin"
						             :groups="groups"
						             :statuses="statuses"
						             :notify="isNotify(appointment,status)">
						</patientCard>
					</div>
<!--				</div>-->
			</div>

		</div>
	</div>
</template>

<script>
import patientCard from "./patientCard";
import Vue from 'vue';
import {EventBus} from "@/main";

export default {
	name: "statusColumn",
	components: {patientCard},
	props: ['status', 'appointments', 'statuses', 'checkNotifications', 'plugin', 'groups'],
	data: function () {
		return {
			foundMap: [],
			oldAppointments: this.appointments,
			lsMap: {},
			sortedWaitAppointments: [],
			sortWaiting: false,
			showNotify: [],
			checkUpRooms: [{
				id: 'mi.rx.dr.01',
				displayName: 'RX Kleedkamer 1A'
			},
				{
					id: 'mi.rx.dr.02',
					displayName: 'RX Kleedkamer 1B'
				}]
		}
	},
	watch: {
		appointments(newList) {
			this.sortedWaitAppointments = [];
			let sortWaiting = localStorage.getItem('sortWaiting')
			if (sortWaiting && sortWaiting === 'true') {
				this.sortWaiting = true;
				this.sortWaitingAppointments(newList);
			}
			this.compare(newList, this.oldAppointments);
			this.oldAppointments = this.appointments;
		},
		showNotify(newList) {
			this.lsMap[this.status.status + this.status.rank] = newList;
			localStorage.setItem("notifyAppointments" + this.plugin, JSON.stringify(this.lsMap));
			this.checkNotifications();
		}
	},
	beforeDestroy() {
		EventBus.$off("removeAllNotifications", this.removeAllNotify);
	},
	mounted() {
		this.getLSitems();
		if (this.appointments) {
			this.oldAppointments = this.appointments;
		}
		let sortWaiting = localStorage.getItem('sortWaiting')
		if (sortWaiting && sortWaiting === 'true') {
			this.sortWaiting = true;
			this.sortWaitingAppointments(this.appointments);
		}
		EventBus.$on("removeAllNotifications", this.removeAllNotify);
	},
	methods: {
		filterAppointments(appointments, checkupRoomId) {
			// To show appointments for a certain checkup room
			let filteredAppo = [];

			appointments.forEach(function (appo) {
				if (appo.checkups[0].calledTo.id === checkupRoomId) {
					filteredAppo.push(appo);
				}
			})
			return filteredAppo;
		},
		getLSitems() {
			let app = this;
			let items = localStorage.getItem("notifyAppointments" + app.plugin);
			let lsitems = {};
			if (items) {
				lsitems = JSON.parse(items);
				app.showNotify = lsitems[app.status.status + app.status.rank];
			} else {
				app.showNotify = [];
				app.statuses.forEach(function (s) {
					lsitems[s.status + s.rank] = [];
				})
			}
			app.lsMap = lsitems;

			if (app.isWaiting(app.status.status)) {
				let waitItems = localStorage.getItem("waitingAppointments");
				let lsWaititems = {};

				if (waitItems) {
					lsWaititems = JSON.parse(waitItems);
					app.showWaitItems = lsWaititems;
				} else {
					app.showWaitItems = [];
					app.appointments.forEach(function (appo) {
						lsWaititems[appo.appointmentId] = appo.index;
					})

					localStorage.setItem("waitingAppointments", JSON.stringify(lsWaititems));
				}
			}
		},
		compare(newList, oldList) {
			let app = this;
			let lastMoved = Vue.prototype.$forwardedAppointment;
			let lastMovedID = lastMoved !== undefined ? lastMoved.patient.appointmentId : null;

			newList.forEach(function (newApp) {
				if (!app.checkInArray(newApp.appointmentId, oldList)) {
					if (lastMovedID === newApp.appointmentId) {
						if ((lastMoved.status.rank + 1) !== app.status.rank) {
							// To check if it was last moved by me but not to this status
							app.pushInNotify(newApp);
						}
					} else {
						app.pushInNotify(newApp);
					}
				}
			});

			if (newList.length === 0) {
				// Empty localstorage for the status where incoming appointments are 0. Helps in DRESSING statuses
				app.lsMap = JSON.parse(localStorage.getItem("notifyAppointments" + app.plugin));
				app.lsMap[app.status.status + app.status.rank] = [];
				localStorage.setItem("notifyAppointments" + app.plugin, JSON.stringify(app.lsMap));
				app.checkNotifications();
			}
		},
		getCurrentCheckup(appointment) {
			let checkups = appointment.checkups;
			for (let i in checkups) {
				let checkup = checkups[i];
				if (this.isStarted(checkup.status)) {
					return checkup;
				}
			}
			return null;
		},
		sortWaitingAppointments(appointments) {
			let appoIndexMap = JSON.parse(localStorage.getItem("waitingAppointments"));
			let app = this;
			let emptyObject = {}
			if (app.isWaiting(app.status.status)) {
				if (appointments.length === 0) {
					localStorage.setItem("waitingAppointments", JSON.stringify(emptyObject));
				}
				app.foundMap = Object.keys(appoIndexMap);
				appointments.forEach(function (newApp) {
					app.checkAndAssignIndex(newApp, appoIndexMap)
					Vue.sortByKeyInt(app.sortedWaitAppointments, 'index');
				})

				if (app.foundMap.length > 0) {
					//remove items from LS map that are removed from waiting status
					let newMap = JSON.parse(localStorage.getItem("waitingAppointments"));
					app.foundMap.forEach(function (appoId) {
						delete newMap[appoId];
					});
					localStorage.setItem("waitingAppointments", JSON.stringify(newMap))
				}
			}
		},
		checkAndAssignIndex(appo, appoIndexMap) {
			//assign the sorted indices from localstorage to waiting appointments
			if (appoIndexMap && appo) {
				if (appoIndexMap[appo.appointmentId] >= 0) {
					appo.index = appoIndexMap[appo.appointmentId]
					let i = this.foundMap.indexOf(appo.appointmentId)
					if (i > -1) {
						//remove items from LS map that are removed from waiting status
						this.foundMap.splice(i, 1)
					}
				} else {
					const maxIndex = Math.max(...Object.values(appoIndexMap));
					appo.index = maxIndex + 1; //Add new appointment as the last element
					appoIndexMap[appo.appointmentId] = appo.index;
					localStorage.setItem("waitingAppointments", JSON.stringify(appoIndexMap))
				}
			}
			this.sortedWaitAppointments.push(appo);
		},
		pushInNotify(appointment) {
			let app = this;
			let appoCheckup = app.getCurrentCheckup(appointment);
			let items = localStorage.getItem("notifyAppointments" + app.plugin);
			let lsitems = {};
			let appointments = [];
			if (items) {
				lsitems = JSON.parse(items);
			} else {
				app.statuses.forEach(function (s) {
					lsitems[s.status + s.rank] = [];
				})
			}

			app.statuses.forEach(function (s) {
				appointments = lsitems[s.status + s.rank];
				for (let i = 0; i < appointments.length; i++) {
					if (appointment.appointmentId === appointments[i]) {
						appointments.splice(i, 1);
					}
				}
				lsitems[s.status + s.rank] = appointments;
			});
			app.lsMap = lsitems;
			if (appoCheckup !== null) {
				if (appoCheckup.rank === app.status.rank) {
					app.showNotify.push(appointment.appointmentId);
				}
			} else {
				app.showNotify.push(appointment.appointmentId);
			}
		},
		fold: function (id) {
			let foldedId = id + "_folded";
			let openId = id + "_open";
			document.getElementById(id).classList.add('folded');
			document.getElementById(foldedId).style.display = 'block';
			document.getElementById(openId).style.display = 'none';
		},
		unfold: function (id) {
			let foldedId = id + "_folded";
			let openId = id + "_open";
			document.getElementById(id).classList.remove('folded');
			document.getElementById(foldedId).style.display = 'none';
			document.getElementById(openId).style.display = 'block';
		},
		checkInArray(id, old) {
			let match = false;
			for (let i = 0; i < old.length; i++) {
				if (old[i].appointmentId === id) {
					match = true;
					break;
				}
			}
			return match;
		},
		removeNotify(appointment, status) {
			let items = localStorage.getItem("notifyAppointments" + this.plugin);
			let lsitems = {};
			let appointments = [];
			if (items) {
				lsitems = JSON.parse(items);
				appointments = lsitems[status.status + status.rank];
				for (let i = 0; i < appointments.length; i++) {
					if (appointment.appointmentId === appointments[i]) {
						appointments.splice(i, 1);
					}
				}
				lsitems[status.status + status.rank] = appointments;
				localStorage.setItem('notifyAppointments' + this.plugin, JSON.stringify(lsitems));
				this.getLSitems();
			}
		},
		removeAllNotify(plugin) {
			localStorage.removeItem('notifyAppointments' + plugin);
			this.getLSitems();
		},
		isNotify(appointment, status) {
			let lsitems = this.lsMap;
			let notify = false;
			let thisApp = appointment.appointmentId;
			if (lsitems) {
				let statusItems = lsitems[status.status + status.rank];
				notify = statusItems === undefined ? false : statusItems.includes(thisApp);
			}
			return notify;
		}
	}
}
</script>

<style scoped>

</style>